import { FDC_TEST_CODE, FDC_TEST_TYPES } from "app/main/apps/scheduler/task-board/shared-components/calibration/calibrationConstants";
import { getCacheData, updateCacheData } from "./cacheFunction";
import { CACHE_APP_DATA, CACHE_KEY_MAP } from "./offlineQueueUtils";

export async function phTestValidations(taskForms, updatedTaskForms) {
  let isDuplicateRdExists = false;
  let isNewStandardRdExists = false;

  // Check duplicate pH test
  const pHDuplicateTest = getPHFieldTest(updatedTaskForms, FDC_TEST_TYPES.DUPLICATE);
  if (pHDuplicateTest && pHDuplicateTest?.fieldTestJson?.value) {
    isDuplicateRdExists = true;
  }

  // Check standard pH test and reading changes
  if (getPHFieldTest(updatedTaskForms, FDC_TEST_TYPES.STANDARD) && isNewPHReadingTaken(taskForms, updatedTaskForms)) {
    isNewStandardRdExists = true;
  }

  // Call updatePhData only once
  if (isDuplicateRdExists || isNewStandardRdExists) {
    await updatePhDataInCache(isDuplicateRdExists, isNewStandardRdExists);
  }
}

// Retrieve cached field items status data
// Set the limit count for calibration and verification requirements
async function updatePhDataInCache(isDuplicateRdExists, isNewStandardRdExists) {
	const cache = await getCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.FIELD_ITEMS_STATUS_URL);
	if (!cache?.data) return;
	const limitCount = 10;
	let updatedCache;

  if (isNewStandardRdExists) {
    const newCount = (cache.data.readingsCount || 0) + 1;
    // Increment readings count and update calibration/verification requirements
    updatedCache = {
			...cache,
			data: {
				...cache.data,
				readingsCount: newCount,
				calibrationRequired: newCount > limitCount ? true : cache.data.calibrationRequired,				
				duplicateReadingsCount: newCount > limitCount ? 0 : (isDuplicateRdExists ? 1 : cache.data.duplicateReadingsCount)
			}
		};
  } else if (isDuplicateRdExists) {
    // Update duplicate readings count if this is a duplicate test
    updatedCache = {
			...cache,
			data: {
				...cache.data,
				duplicateReadingsCount: 1
			}
		};
  }	

	// Save the updated data back to cache
	await updateCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.FIELD_ITEMS_STATUS_URL, updatedCache);
}

function isNewPHReadingTaken(taskForms, updatedTaskForms) {
  const currentVal = normalize(getPHFieldTest(taskForms)?.fieldTestJson?.value);
  const updatedVal = normalize(getPHFieldTest(updatedTaskForms)?.fieldTestJson?.value);

  return updatedVal !== null && currentVal !== updatedVal;
}

function normalize(val) {
  return val == null || val === "" ? null : val;
}

function getPHFieldTest(forms, testType) {
  return forms?.[0]?.formData?.sampleFieldTests?.find(
    t => t.testCode === FDC_TEST_CODE.pH && t.testType === testType
  );
}

// Fn to set duplicate ph test if offline
export async function insertPhDuplicateOffline(task) {
  const { taskForms = [] } = task;

  const updatedTaskForms = await Promise.all(
    taskForms.map(async form => {
      const tests = form.formData?.sampleFieldTests || [];
      const hasStandard = tests.some(
        t => t.testCode === FDC_TEST_CODE.pH && t.testType === FDC_TEST_TYPES.STANDARD
      );
      const hasDuplicate = tests.some(
        t => t.testCode === FDC_TEST_CODE.pH && t.testType === FDC_TEST_TYPES.DUPLICATE
      );

      // Only add if standard exists and duplicate does not
      if (hasStandard && !hasDuplicate) {
        const calibStatusObj = await getCacheData(
          CACHE_APP_DATA,
          CACHE_KEY_MAP.FIELD_ITEMS_STATUS_URL
        );        
        let insertDuplicateTest = true; // default true
        if (calibStatusObj?.data?.duplicateReadingsCount !== undefined) {
          insertDuplicateTest = calibStatusObj.data.duplicateReadingsCount === 0;
        }

        if (insertDuplicateTest) {
          const phStandardIndex = tests.findIndex(
            t => t.testCode === FDC_TEST_CODE.pH && t.testType === FDC_TEST_TYPES.STANDARD
          );

          const duplicateTest = {
            testCode: FDC_TEST_CODE.pH,
            testType: FDC_TEST_TYPES.DUPLICATE,
            fieldTestJson: {}
          };

          const newTests = [
            ...tests.slice(0, phStandardIndex + 1),
            duplicateTest,
            ...tests.slice(phStandardIndex + 1)
          ];

          return {
            ...form,
            formData: {
              ...form.formData,
              sampleFieldTests: newTests
            }
          };
        }
      }

      return form; // unchanged form
    })
  );

  return {
    ...task,
    taskForms: updatedTaskForms
  };
}

